
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface ContentItem {
  id: string;
  title: string;
  status: "published" | "draft" | "scheduled";
  date: string;
  views: number;
}

interface RecentArticlesProps {
  items: ContentItem[];
}

export function RecentArticles({ items }: RecentArticlesProps) {
  return (
    <Card className="h-full flex flex-col">
      <CardHeader>
        <CardTitle>Recent Articles</CardTitle>
      </CardHeader>
      <CardContent className="flex-1 overflow-auto">
        <div className="space-y-4">
          {items.map((item) => (
            <div key={item.id} className="flex items-start justify-between border-b pb-4 last:border-0 last:pb-0">
              <div>
                <div className="font-medium">{item.title}</div>
                <div className="mt-1 flex items-center gap-2 text-xs text-muted-foreground">
                  <span>{item.date}</span>
                  <span>•</span>
                  <span
                    className={
                      item.status === "published"
                        ? "text-green-500"
                        : item.status === "scheduled"
                        ? "text-yellow-500"
                        : "text-gray-500"
                    }
                  >
                    {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                  </span>
                </div>
              </div>
              <div className="text-sm">
                <span className="font-medium">{item.views.toLocaleString()}</span>
                <span className="ml-1 text-xs text-muted-foreground">views</span>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
